<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel gs-widget-cardmargin-bottom-5"
    *ngIf="userType=='RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'|| userType=='FREELANCE_RECRUITER'">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>
    <ng-container *ngIf="candidatefilter =='false'&&!loadAPIcall|| candidatefilter==undefined&&!loadAPIcall">

      <div class="panel-heading gs-widget-headerhbuilt wig-c">
        {{ headerTitle }}
        <span style="float: right;cursor: pointer;" title="Refresh" (click)="refereshFeatureCandidates()"><ng-icon name="tablerRefresh"></ng-icon></span>
      </div>
      <div class="panel-body gs-widget-bodyno-padding">
        <div class="row">
          <div class="col-lg-12 pad-24px">
            <ul class="profile-list">
              <!-- <p headline1>No featured candidates found.</p> -->
              <ng-container *ngIf="response | async as responseData">
                <!-- <app-common-profile-info [userIdInput]="item.candidateReferenceId"
                      [page]="'CANDIDATES'" [data]="item" (click)="getSingleCandi(item.candidateReferenceId,true)"  >
                          <ng-container headline1>{{item.firstName}}  {{item.lastName}} </ng-container>
                          <ng-container headline2>{{item.jobTitle}} </ng-container>
                      </app-common-profile-info> -->

                <ng-container *ngIf="responseData && responseData.length > 0">
                  <app-common-profile-info *ngFor="let item of responseData | slice:0:3" [userIdInput]="item.createdBy"
                    [page]="'CANDIDATES'" [data]="item" (click)="redirect(item)">

                    <ng-container headline1>{{item.firstName|titlecase}} {{item.lastName|titlecase}} </ng-container>
                    <div headline2 [title]="item.jobTitle"><span>{{item.jobTitle}}</span></div>
                    <div headline2 style="margin: 0px 0px 0px;" *ngIf="item?.matchingTitles!=null" [title]="item.matchingTitles">
                      <span>
                        Job title match:
                      </span>
                      <span title="{{item?.matchingTitles}}">
                        {{item?.matchingTitles}}
                      </span>
                    </div>
                    <div headline2 style="margin: 0px 0px 0px; " *ngIf="item?.matchingPrimarySkils!=null" [title]="item.matchingPrimarySkils">
                      <span>
                        Primary skill match:
                      </span>
                      <span title="{{item?.matchingPrimarySkils}}">
                        {{item?.matchingPrimarySkils}}
                      </span>
                    </div>
                    <div headline2 style="margin: 0px 0px 0px;" *ngIf="item?.matchingSecondarySkils!=null" [title]="item.matchingSecondarySkils">
                      <span>
                        Secondary skill match :
                      </span>
                      <span title="{{item?.matchingSecondarySkils}}">
                        {{item?.matchingSecondarySkils}}
                      </span>
                    </div>

                  </app-common-profile-info>
                </ng-container>

                <!-- <p style="float: right;" *ngIf="feaCandiCount> 2">
                  <u><a data-toggle="tooltip" style="float: right;" data-placement="top" title="More"
                      (click)="modelopen(response,false,'')">...More</a></u>
                </p> -->

                <button class="gs-743-more-btn" type="button"
                        *ngIf="responseData.length > 0"
                        (click)="modelopen(response,false,'')">
                  View more →
                </button>


                <div class="gs-empty" *ngIf="!responseData || responseData.length === 0">
                  <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
                  <div class="gs-empty-title">No suggestions yet</div>
                  <div class="gs-empty-sub">Start creating jobs to see relevant candidate matches.</div>
                </div>

              </ng-container>

              <!-- <p *ngIf="response==null||response?.length==0"> No data Found </p> -->

            </ul>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'" infiniteScroll
  [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="2000" (scrolled)="onScrollDown()">

  <div class="panel-body gs-widget-bodycardw">
    <div class="row">
      <div class="col-12">

        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="10"
          [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>


        <div *ngIf="sugges!=null && !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5">
            <app-candidate-card [viewSize]="'large'" [candidateval]="sugges"
              [From]="'FEATURED_CANDIDATE'" [actionMenuEnabled]="true"></app-candidate-card>
          </div>
        </div>
        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="(response | async )?.length == 0 && !loadAPIcall">
          <div class="gs-empty">
            <span class="gs-empty-icon"><ng-icon name="tablerUserCircle"></ng-icon></span>
            <div class="gs-empty-title">No featured candidates yet</div>
            <div class="gs-empty-sub">Featured candidates will show up here as they're added.</div>
          </div>
        </div>

        <div *ngIf="sugges==null && !loadAPIcall">

          <div class="col-md-12 padding-left-0 padding-right-5" *ngFor="let item of response | async">
            <app-candidate-card [viewSize]="'large'" [candidateval]="item"
              [From]="'FEATURED_CANDIDATE'" [actionMenuEnabled]="true"></app-candidate-card>
          </div>

          <div class="col-sm-12 pl-1 end" *ngIf="responseStopScroll&&(response | async )?.length>0"
            style="text-align: center;padding-top: 1rem;">
            <div class="col-sm-12">
              <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
              <ng-icon name="tablerCircleCheck"></ng-icon>

            </div>
            <div class="col-sm-12">
              <p class="biase">You've reached the bottom of the page</p>
            </div>
          </div>
          <!--
          <div *ngIf="(response | async ) === null || (response | async )?.length === 0" class="col-md-12 padding-left-0 padding-right-5">
            <div appQueryDOM [response]="resultContent" class="empty-message-container">
              <img src='assets/images/empty-page-picture.png' alt="">
              <div class="empty-message" #empty>Fetching featured Candidate....</div>
            </div>
          </div> -->
        </div>


      </div>


    </div>
  </div>

</div>